import { computed } from 'vue'
import { useCurUser } from '@/composables/useCurUser'

export const registerOwnerColumn = (dashboard, { requests }) => {
  const { hasRole } = useCurUser()

  dashboard.registerCustomColumn({
    name: 'owner',
    label: 'monolith.shared.owner',
    component: (props) => {
      const owner = props.row.owner

      if (!owner) {
        return null
      }

      return owner.email
    },
    options: {
      searchable: true,
      filter: 'owner__info',
      visible: computed(() => {
        // TODO: upgrade product to avoid role based rendering of columns/dashboard
        return hasRole('dispatcher') || !requests.isUserRequests.value
      }),
    },
  })
}
